import anime from "animejs";

export default () => ({
    init(){
        anime({
            targets: "#simple-loader",
            rotate: '1turn',
            loop: true,
            easing: 'easeInOutQuad',
            duration: 500
        });
    }
});
